import { render } from "./HiPdfViewer.vue?vue&type=template&id=6f8d972d"
import script from "./HiPdfViewer.vue?vue&type=script&lang=js"
export * from "./HiPdfViewer.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__